module.exports = __webpack_public_path__ + "static/media/elo_cleared.276ebfcc.mp3";